define("shared/utils/plans-data/feature-mappings", ["exports", "shared/utils/plans-data/feature-keys"], function (_exports, _featureKeys) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/plans-data/feature-keys"eaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class featureMappingsUtil
   * @extends Utils
   */

  /**
   * Maps features on features object
   *
   * @method featureMappings
   * @param {Service} intl
   *
   * @returns {Object} Features with specific copy
   */
  const featureMappings = (intl, plan) => ({
    exportAnalytics: _ref => {
      let {
        analyticsExport
      } = _ref;
      return analyticsExport ? intl.t('plans.analytics_export_csv') : true;
    },
    featuredMedia: _ref2 => {
      let {
        linkinbioFeaturedMediaImage,
        linkinbioFeaturedMediaVideo
      } = _ref2;
      let featureAccess = false;

      if (linkinbioFeaturedMediaImage) {
        featureAccess = intl.t('plans.linkin_bio_post');
      }

      if (linkinbioFeaturedMediaVideo) {
        featureAccess = intl.t('plans.linkin_bio_video');
      }

      return featureAccess;
    },
    groups: _ref3 => {
      let {
        accessGroups
      } = _ref3;
      return accessGroups ? intl.t('plans.feature_mappings.unlimited') : intl.t('plans.feature_mappings.one');
    },
    igAnalytics: _ref4 => {
      let {
        analyticsExport
      } = _ref4;
      return analyticsExport ? intl.t('plans.feature_mappings.full') : intl.t('plans.feature_mappings.limited');
    },
    igPostPerformance: _ref5 => {
      let {
        analyticsExport
      } = _ref5;
      return analyticsExport ? intl.t('plans.full_posts') : intl.t('plans.limited_posts');
    },
    igStoryPerformance: _ref6 => {
      let {
        analyticsExport
      } = _ref6;
      return analyticsExport ? intl.t('plans.full_posts') : false;
    },
    linkinbio: _ref7 => {
      let {
        linkinbioButtonColor,
        linkinbioStandard
      } = _ref7;
      let featureAccess = true;

      if (linkinbioButtonColor) {
        featureAccess = intl.t('plans.linkin_bio_plus_button_colors');
      }

      if (linkinbioStandard) {
        const linksLimit = 5;
        featureAccess = "".concat(intl.t('plans.linkin_bio_featured_media'), "<br>").concat(intl.t('plans.linkin_bio_shopify_links', {
          count: linksLimit
        }));
      }

      return featureAccess;
    },
    linkinbioAnalytics: _ref8 => {
      let {
        analyticsExport
      } = _ref8;
      return analyticsExport ? "".concat(intl.t('plans.full_posts'), "<br>").concat(intl.t('plans.linkin_bio_page_views')) : intl.t('plans.limited_months');
    },
    linkinbioButton: _ref9 => {
      let {
        linkinbioButtonColor
      } = _ref9;
      let featureAccess = true;

      if (linkinbioButtonColor) {
        featureAccess = intl.t('plans.custom_color');
      }

      return featureAccess;
    },
    linkinbioSocialPosts: _ref10 => {
      let {
        linkinbioLinkedSocialPosts
      } = _ref10;
      const limitedPosts = 1;
      const largeSocialPosts = 5;
      const limitedLinkedSocialPosts = linkinbioLinkedSocialPosts ? largeSocialPosts : limitedPosts;
      const postAmountPerPlatform = plan.canMultipleLinkinbioFeeds ? intl.t('plans.linkin_bio_social_posts_amount_tiktok', {
        count: limitedLinkedSocialPosts
      }) : intl.t('plans.linkin_bio_social_posts_amount', {
        count: limitedLinkedSocialPosts
      });
      return postAmountPerPlatform;
    },
    mediaEditing: _ref11 => {
      let {
        videoCoverSelect,
        textOnImages
      } = _ref11;
      let featureAccess = true;

      if (videoCoverSelect) {
        featureAccess = intl.t('plans.video_thumbnail');
      }

      if (textOnImages) {
        featureAccess = "+".concat(intl.t('plans.text_on_image'));
      }

      return featureAccess;
    },
    twitterPinterestAnalytics: features => {
      let featureAccess = false;

      if (features.twitterClickTracking && features.pinterestClickTracking) {
        featureAccess = intl.t('plans.click_tracking');
      } else if (features.twAnalytics && features.pinAnalytics) {
        featureAccess = intl.t('plans.limited_months');
      }

      return featureAccess;
    }
  });
  /**
   * Maps plan feature details
   *
   * @method planFeatures
   * @param {Service} intl
   *
   * @returns {Object} plan features with specific copy
   */


  const planFeatures = intl => ({
    amount: plan => {
      const amounts = {
        yearlyPrice: plan.isYearly ? plan.amount : plan.amount * 10,
        monthlyPrice: plan.isMonthly ? plan.amount : plan.amount / 10
      };
      amounts.monthlyPriceBilledYearly = amounts.yearlyPrice !== 0 ? Math.round(amounts.yearlyPrice / 12) : 0;
      return amounts;
    },
    hashtagSuggestions: plan => {
      let featureAccess = false;

      if (plan.numberOfHashtagSearches === -1) {
        featureAccess = intl.t('plans.feature_mappings.unlimited');
      }

      if (plan.hasLimitedHashtagSearches) {
        featureAccess = intl.t('plans.hashtag_suggestions', {
          count: plan.numberOfHashtagSearches
        });
      }

      return {
        hashtagSuggestions: featureAccess
      };
    },
    mediaStorage: plan => ({
      mediaStorage: intl.t('plans.media_storage_size', {
        photo: plan.imageSizeLimit,
        video: plan.videoSizeLimit
      })
    }),
    numberOfPosts: plan => ({
      posts: plan.numberOfPosts === -1 ? intl.t('plans.feature_mappings.unlimited') : "".concat(plan.numberOfPosts),
      postsNumber: plan.numberOfPosts
    }),
    numberOfSocialSets: plan => {
      let extraSocialSets = 0;
      let extraSocialSetsYearly = 0;

      if (plan.canAddSocialSets) {
        extraSocialSets = Math.round(plan.additionalSocialSetCosts.monthly.dollars * 100) / 100;
        extraSocialSetsYearly = Math.round(plan.additionalSocialSetCosts.yearly.cents * 100 / 100);
      }

      return {
        socialSets: plan.numberOfSocialSets,
        extraSocialSets,
        extraSocialSetsYearly
      };
    },
    numberOfUsers: plan => {
      let extraUsers = 0;
      let extraUsersYearly = 0;

      if (plan.canAddUsers) {
        extraUsers = Math.round(plan.additionalUserCosts.monthly.dollars * 100) / 100;
        extraUsersYearly = Math.round(plan.additionalUserCosts.yearly.cents * 100 / 100);
      }

      return {
        users: plan.numberOfUsers,
        extraUsers,
        extraUsersYearly
      };
    },
    tags: plan => {
      let featureAccess = false;

      if (plan.numberOfCollectTags === -1) {
        featureAccess = intl.t('plans.add_unlimited_media');
      }

      if (plan.hasLimitedCollectTags) {
        featureAccess = intl.t('plans.collect_tags', {
          count: plan.numberOfCollectTags
        });
      }

      return {
        tags: featureAccess
      };
    },
    features: plan => {
      const features = {};

      for (const [key, value] of Object.entries(_featureKeys.default)) {
        Object.assign(features, {
          [key]: plan.features[value]
        });
      }

      const featuresMappings = featureMappings(intl, plan);
      return { ...Object.assign(...Object.keys(featuresMappings).map(key => ({
          [key]: featuresMappings[key](features)
        }))),
        ...features
      };
    }
  });

  var _default = planFeatures;
  _exports.default = _default;
});